import { useExperienceModuleContext } from '../context';
import { ExperienceEntity, ExperienceEntityType } from '../types';
import { recursiveFindEntity, recursiveGetOfType } from '../utils';

export const useExperienceEntityVenues = (): ExperienceEntity[] => {
  const { experienceEntityTree } = useExperienceModuleContext();
  return recursiveGetOfType(experienceEntityTree, ExperienceEntityType.VENUE);
};

/**
 * Returns the venues of the selected entity from the drop down. If the selected entity is a venue, it returns the venue
 * itself.
 * Common example is in the ExperienceInsights component. Where if you have selected brand on top of the page, it will
 * return all the venues of that brand.
 */
export const useSelectedEntityVenues = (): ExperienceEntity[] => {
  const { selectedExperienceEntity, experienceEntityTree } = useExperienceModuleContext();

  const selectedExperienceEntityInTree = recursiveFindEntity(
    experienceEntityTree,
    selectedExperienceEntity.experienceEntityId,
  );
  if (!selectedExperienceEntityInTree) {
    return [];
  }

  return recursiveGetOfType(selectedExperienceEntityInTree, ExperienceEntityType.VENUE);
};
